import { useEffect, useState } from "react"
import header_photo from "./img/header-photo.png"
import freedom_1 from "./img/personal-freedom.svg"
import freedom_2 from "./img/time-freedom.svg"
import freedom_3 from "./img/financial-success.svg"
import flexibility from "./img/flexibility.svg"
import pain_points_1 from "./img/pain-points-1.png"
import pain_points_2 from "./img/pain-points-2.jpg"
import pain_points_3 from "./img/pain-points-3.jpg"
import rewarding_job from "./img/global-reach.svg"
import professional_success from "./img/professional-success.svg"
import CountUp from './CountUp'
import AnimatedTypeComponent from "./AnimatedTypeComponent"
import FAQ from "./FAQ"
import Quiz from './Quiz'

const business_types = [
	{ type: "TEACHING ", fontClass: "" },
	{ type: "COACHING ", fontClass: "" },
	{ type: "TRAINING ", fontClass: "" },
	{ type: "TUTORING ", fontClass: "" },
]

const Landing = () => {
	const [showQuiz, setShowQuiz] = useState(false)
	const [nameValue, setNameValue] = useState('')
	const [emailValue, setEmailValue] = useState('')
	const [acceptTerms, setAcceptTerms] = useState(false)
	const [inputError, setInputError] = useState(false)
	const [nameError, setNameError] = useState(false)
	const [emailError, setEmailError] = useState(false)
	const [isValid, setIsValid] = useState(false)

	const handleFormSubmit = (e) => {
		e.preventDefault()
		if (acceptTerms && nameValue !== '' && isValid) {
			e.target.submit()
		} else {
			if (!isValid) {
				setEmailError(true)
			}
			if (nameValue === '') {
				setNameError(true)
			}
			if (!acceptTerms) {
				setInputError(true)
			}
			setTimeout(() => {
				setNameError(false)
				setEmailError(false)
				setInputError(false)
			}, 3000)
		}
	}

	useEffect(() => {
		setIsValid(isValidEmail(emailValue))
	}, [emailValue])

	const isValidEmail = (email) => {
		
		// eslint-disable-next-line no-useless-escape
		const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
		return regex.test(email)
	}

	const handleAcceptTerms = async () => {
		await setAcceptTerms(!acceptTerms)
	}

	return (
		<>
			<header>
				<div className="container px-4">
					<div className="py-4 flex w-full justify-between align-center">
						<span className="text-selectiveGreen font-bold font-sans text-2xl">Learn<span className="text-selectiveYellow">To</span>Tutor</span>
						{/* <a href="https://ebook-sale.com" className="bg-jet text-white rounded-[10px] py-3 px-4 font-semibold text-sm text-center">
							EBOOK SALE
						</a> */}
					</div>
				</div>
				<div className="rounded-t-[64px] bg-whiteSmoke py-12">
					<div className="container px-4">
						<div className="grid gap-4 md:grid-cols-2 items-center mb-6">
							<div>
								<div className="max-w-half">
									<h1 className="font-bold uppercase text-black text-[30px] lg:leading-[48px] lg:text-[40px] xl:text-[56px] xl:leading-[64px] mb-4 w-full tracking-tight">
										<AnimatedTypeComponent types={business_types} />
									</h1>
									<p className="text-[22px] w-full">
										Earn more. Work effectively. Live independently.
									</p>
								</div>
							</div>
							<div className="min-h-[400px] rounded-[24px] bg-gradient-to-b from-bg-seasalt to-bg-whiteSmoke">
								<img src={header_photo} alt="Learn to tutor header" className="rounded-[24px]" />
							</div>
						</div>
						<div id="mc_embed_shell">
							<div id="mc_embed_signup">
								<form action="https://gmail.us18.list-manage.com/subscribe/post?u=3ca6323487982d5873fa80dd5&amp;id=0f7fa9b6eb&amp;f_id=001ec7e0f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_self" onSubmit={handleFormSubmit}>
									<div id="mc_embed_signup_scroll" className="grid gap-6 grid-cols-1 lg:grid-cols-3">
										<label htmlFor="mce-FNAME">
											<span className="text-davyGray font-semibold text-sm w-full mb-2 block">
												Name
											</span>
											<input type="text" name="FNAME" value={nameValue} onChange={(e) => { setNameValue(e.target.value) }}
												className={`w-full py-3 px-4 rounded-[10px] border-[0.5px] border-solid ${nameError ? 'border-red-400' : 'border-davyGray'} outline-0 bg-transparent font-normal text-davyGray`} placeholder="Provide your name" id="mce-FNAME" />
										</label>
										<label htmlFor="mce-EMAIL">
											<span className="text-davyGray font-semibold text-sm w-full mb-2 block">
												Email
											</span>
											<input type="email" name="EMAIL" value={emailValue} onChange={(e) => { setEmailValue(e.target.value) }}
												className={`w-full py-3 px-4 rounded-[10px] border-[0.5px] border-solid ${emailError ? 'border-red-400' : 'border-davyGray'} outline-0 bg-transparent font-normal text-davyGray`} placeholder="Provide your e-mail" id="mce-EMAIL" />
										</label>
										<div className="pt-7">
											<button type="submit" className="w-full py-3 px-4 rounded-[10px] bg-selectiveGreen text-white uppercase font-semibold text-sm min-h-[48px] mb-2 flex items-center justify-between">
												Enroll in the training program
												<svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z" fill="white"></path>
												</svg>
											</button>
											<label>
												<input style={{ marginRight: '5px' }} checked={acceptTerms} onChange={handleAcceptTerms} type="checkbox" name="privacy" />
												<span className={`text-sm font-semibold ml-2 ${inputError ? 'text-red-400 underline' : 'text-davyGray'}`}>
													I accept the <a href="https://learntotutor.com/docs/PrivacyPolicy.pdf" rel="noreferrer" className="underline" target="_blank">privacy policy</a>
												</span>
											</label>
										</div>
										<div id="mce-responses" className="clear foot">
											<div className="response" id="mce-error-response hidden"></div>
											<div className="response" id="mce-success-response hidden"></div>
										</div>
										<div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
											{/*real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
											<input type="text" name="b_3ca6323487982d5873fa80dd5_0f7fa9b6eb" tabIndex="-1" />
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div >
			</header >

			<section className="bg-whiteSmoke relative">
				<div className="bg-white absolute w-full h-1/2 left-0 right-0 bottom-0 z-0"></div>
				<div className="container px-4 relative z-10">
					<div className="rounded-[24px] bg-jet p-8 grid grid-cols-1 md:grid-cols-3 gap-6 justify-between bg-repeat md:animate-ltr-linear-infinite bg-numbers-texture">
						<div>
							<span className="text-[56px] text-white font-semibold block text-center">
								+<CountUp delay={600} end={12} />k
							</span>
							<p className="text-white text-sm font-semibold block text-center">
								COACHING SESSIONS
							</p>
						</div>
						<div>
							<span className="text-[56px] text-white font-semibold block text-center">
								+<CountUp delay={900} end={500} />
							</span>
							<p className="text-white text-sm font-semibold block text-center">
								TRAININGS
							</p>
						</div>
						<div>
							<span className="text-[56px] text-white font-semibold block text-center">
								+<CountUp delay={1200} end={12} />
							</span>
							<p className="text-white text-sm font-semibold block text-center">
								YEARS
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className="pt-16 relative">
				<div className="bg-whiteSmoke absolute w-full h-32 left-0 right-0 bottom-0 z-0"></div>
				<div className="container px-4">
					<div className="flex w-full justify-center mb-14">
						<div className="max-w-[550px]">
							<h2 className="text-[32px] text-jet font-semibold text-center mb-4">
								Leverage your potential and redefine your career
							</h2>
							<p className="text-base text-jet font-normal text-center">
								Tired of feeling undervalued and stuck in the system? Say goodbye to burn out, low rates, and struggling to find clients. Build your own thriving business, and transition to stability and recognition. As an independent educator and coach you take control, set your own rates, and attract motivated students.

							</p>
						</div>
					</div>
					<div className="grid md:grid-cols-3 gap-6">
						<div className="group rounded-[24px] bg-whiteSmoke hover:bg-selectiveGreen transition-all duration-200 overflow-hidden relative">
							<div className="p-8 md:min-h-[162px] flex flex-wrap justify-center">
								<h3 className="text-[22px] text-jet font-medium text-center group-hover:text-white transition-all duration-200 w-full">
									Online tutors
								</h3>
								<div className="md:opacity-0 group-hover:opacity-100 flex flex-wrap justify-center">
									<div className="h-px w-[72px] group-hover:bg-white bg-jet transition-colors duration-200 my-3"></div>
									<p className="text-jet group-hover:text-white text-sm text-center w-full">
										Work with flexibility and set your own rates.
									</p>
								</div>
							</div>
							<div className="md:min-h-[235px] relative md:-mt-16">
								<img src={pain_points_1} alt="Online tutors" className="rounded-[24px] min-h-[235px] md:absolute md:left-0 md:right-0 md:bottom-0 transform md:group-hover:translate-y-[64px] transition-all duration-500 object-cover w-full md:w-auto" />
							</div>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke hover:bg-selectiveGreen transition-all duration-200 overflow-hidden relative">
							<div className="p-8 md:min-h-[162px] flex flex-wrap justify-center">
								<h3 className="text-[22px] text-jet font-medium text-center group-hover:text-white transition-all duration-200 w-full">
									Public teachers
								</h3>
								<div className="md:opacity-0 group-hover:opacity-100 flex flex-wrap justify-center">
									<div className="h-px w-[72px] group-hover:bg-white bg-jet transition-colors duration-200 my-3"></div>
									<p className="text-jet group-hover:text-white text-sm text-center w-full">
										Regain your work-life balance and work with motivated students.
									</p>
								</div>
							</div>
							<div className="md:min-h-[235px] relative md:-mt-16">
								<img src={pain_points_2} alt="Public teachers" className="rounded-[24px] min-h-[235px] md:absolute md:left-0 md:right-0 md:bottom-0 transform md:group-hover:translate-y-[64px] transition-all duration-500 object-cover w-full md:w-auto" />
							</div>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke hover:bg-selectiveGreen transition-all duration-200 overflow-hidden relative">
							<div className="p-8 md:min-h-[162px] flex flex-wrap justify-center">
								<h3 className="text-[22px] text-jet font-medium text-center group-hover:text-white transition-all duration-200 w-full">
									Online coaches
								</h3>
								<div className="md:opacity-0 group-hover:opacity-100 flex flex-wrap justify-center">
									<div className="h-px w-[72px] group-hover:bg-white bg-jet transition-colors duration-200 my-3"></div>
									<p className="text-jet group-hover:text-white text-sm text-center w-full">
										Find clients easily and build a stable coaching business.
									</p>
								</div>
							</div>
							<div className="md:min-h-[235px] relative md:-mt-16">
								<img src={pain_points_3} alt="Online coaches" className="rounded-[24px] min-h-[235px] md:absolute md:left-0 md:right-0 md:bottom-0 transform md:group-hover:translate-y-[64px] transition-all duration-500 object-cover w-full md:w-auto" />
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="bg-whiteSmoke py-16">
				<div className="container px-4 relative">
					<div className="control-arrows absolute transform -translate-y-1/2 top-1/2 z-10 inset-x-4 inset-y-0 flex justify-between items-center" aria-label="Carousel Navigation" tabIndex="0">
						<button className="previous-button px-2 md:px-4 py-4 flex justify-center items-center bg-davyGray rounded-full md:w-[70px]" aria-controls="tns1" tabIndex="-1" data-controls="prev">
							<svg width="25" height="8" className="transform rotate-180" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z" fill="white"></path>
							</svg>
						</button>
						<button className="next-button px-2 md:px-4 py-4 flex justify-center items-center bg-davyGray rounded-full md:w-[70px]" aria-controls="tns1" tabIndex="-1" data-controls="next">
							<svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z" fill="white"></path>
							</svg>
						</button>
					</div>
					<div className="tns-outer" id="tns1-ow"><div className="tns-nav" aria-label="Carousel Pagination"><button data-nav="0" aria-controls="tns1" aria-label="Carousel Page 1 (Current Slide)" className="tns-nav-active"></button><button data-nav="1" tabIndex="-1" aria-controls="tns1" aria-label="Carousel Page 2"></button><button data-nav="2" tabIndex="-1" aria-controls="tns1" aria-label="Carousel Page 3"></button></div><div className="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span className="current">2</span>  of 3</div><div id="tns1-mw" className="tns-ovh"><div className="tns-inner" id="tns1-iw"><div className="js-testimonials z-20  tns-slider tns-carousel tns-subpixel tns-calc tns-horizontal" id="tns1" style={{ transitionDuration: "0s", transform: "translate3d('-20%', 0, 0)" }}><div className="tns-item" aria-hidden="true" tabIndex="-1">
						<div className="w-full flex justify-center px-[80px]">
							<div className="max-w-[750px] w-full">
								<div className="w-full flex justify-center items-center mb-4">
									<svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M52 12.0659C52 22.68 44.3983 28.9959 39.6591 31.9032C39.0577 32.2719 38.4088 31.5058 38.8686 30.9693C40.3457 29.2446 42.0701 26.7791 43.2333 23.6709C42.18 23.9712 41.0678 24.1313 39.919 24.1313C33.247 24.1313 27.8379 18.7295 27.8379 12.0653C27.8379 5.40113 33.247 0 39.919 0C46.5909 0 52 5.40173 52 12.0659Z" fill="#C5C5C5"></path>
										<path d="M24.1615 12.0659C24.1615 22.68 16.5599 28.9959 11.8206 31.9032C11.2192 32.2719 10.5703 31.5058 11.0301 30.9693C12.5072 29.2446 14.2316 26.7791 15.3948 23.6709C14.3415 23.9712 13.2293 24.1313 12.0805 24.1313C5.40851 24.1313 0 18.7295 0 12.0659C0 5.40233 5.40851 0 12.0811 0C18.7536 0 24.1621 5.40173 24.1621 12.0659H24.1615Z" fill="#C5C5C5"></path>
									</svg>
								</div>
								<p className="text-center text-base mb-4">
									I am a certified nutritionist and personal trainer. Since 2020 I have tried to grow my online coaching business. I tried a thousand things.. But business didn't go anywhere. Mona helped me to rethink my strategies, find the niche that fits me best, and create a work environment that is sustainable for me. I have been able to raise my rates step by step. Super content with the training and especially the mentorship really helped me turn things around. I wish I had done it earlier.
								</p>
								<span className="font-semibold text-sm text-center w-full block">
									Health coach                        </span>
							</div>
						</div>
					</div>
						<div className="tns-item tns-slide-active" id="tns1-item0">
							<div className="w-full flex justify-center px-[80px]">
								<div className="max-w-[750px] w-full">
									<div className="w-full flex justify-center items-center mb-4">
										<svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M52 12.0659C52 22.68 44.3983 28.9959 39.6591 31.9032C39.0577 32.2719 38.4088 31.5058 38.8686 30.9693C40.3457 29.2446 42.0701 26.7791 43.2333 23.6709C42.18 23.9712 41.0678 24.1313 39.919 24.1313C33.247 24.1313 27.8379 18.7295 27.8379 12.0653C27.8379 5.40113 33.247 0 39.919 0C46.5909 0 52 5.40173 52 12.0659Z" fill="#C5C5C5"></path>
											<path d="M24.1615 12.0659C24.1615 22.68 16.5599 28.9959 11.8206 31.9032C11.2192 32.2719 10.5703 31.5058 11.0301 30.9693C12.5072 29.2446 14.2316 26.7791 15.3948 23.6709C14.3415 23.9712 13.2293 24.1313 12.0805 24.1313C5.40851 24.1313 0 18.7295 0 12.0659C0 5.40233 5.40851 0 12.0811 0C18.7536 0 24.1621 5.40173 24.1621 12.0659H24.1615Z" fill="#C5C5C5"></path>
										</svg>
									</div>
									<p className="text-center text-base mb-4">
										After 7 years working as a public teacher I needed a break. I love teaching, but dealing with uncooperative parents, admin, and unmotivated students sent me into a burn out. I tried private online teaching but couldn't find many students. Mona helped me navigate through all of it, marketing, content creation, even opened up new paths I could monetise right away. I'm fully booked and already built a waiting list. I'm a maths teacher and teach maths and EFL for stem online.
									</p>
									<span className="font-semibold text-sm text-center w-full block">
										Public school teacher                        </span>
								</div>
							</div>
						</div>
						<div className="tns-item" id="tns1-item1" aria-hidden="true" tabIndex="-1">
							<div className="w-full flex justify-center px-[80px]">
								<div className="max-w-[750px] w-full">
									<div className="w-full flex justify-center items-center mb-4">
										<svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M52 12.0659C52 22.68 44.3983 28.9959 39.6591 31.9032C39.0577 32.2719 38.4088 31.5058 38.8686 30.9693C40.3457 29.2446 42.0701 26.7791 43.2333 23.6709C42.18 23.9712 41.0678 24.1313 39.919 24.1313C33.247 24.1313 27.8379 18.7295 27.8379 12.0653C27.8379 5.40113 33.247 0 39.919 0C46.5909 0 52 5.40173 52 12.0659Z" fill="#C5C5C5"></path>
											<path d="M24.1615 12.0659C24.1615 22.68 16.5599 28.9959 11.8206 31.9032C11.2192 32.2719 10.5703 31.5058 11.0301 30.9693C12.5072 29.2446 14.2316 26.7791 15.3948 23.6709C14.3415 23.9712 13.2293 24.1313 12.0805 24.1313C5.40851 24.1313 0 18.7295 0 12.0659C0 5.40233 5.40851 0 12.0811 0C18.7536 0 24.1621 5.40173 24.1621 12.0659H24.1615Z" fill="#C5C5C5"></path>
										</svg>
									</div>
									<p className="text-center text-base mb-4">
										Thank you Mona! I'm finally flexible and can work from home while studying! I'll keep growing my tutor business as a side hustle. The program was amazing, it took me less than a month to hit my target. College takes up most of my time, so we set up a 10 hr/week work schedule for my tutoring, and automated most backoffice tasks. Thanks for helping me getting through university Mona! &lt;3
									</p>
									<span className="font-semibold text-sm text-center w-full block">
										ESL tutor                        </span>
								</div>
							</div>
						</div>
						<div className="tns-item" id="tns1-item2" aria-hidden="true" tabIndex="-1">
							<div className="w-full flex justify-center px-[80px]">
								<div className="max-w-[750px] w-full">
									<div className="w-full flex justify-center items-center mb-4">
										<svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M52 12.0659C52 22.68 44.3983 28.9959 39.6591 31.9032C39.0577 32.2719 38.4088 31.5058 38.8686 30.9693C40.3457 29.2446 42.0701 26.7791 43.2333 23.6709C42.18 23.9712 41.0678 24.1313 39.919 24.1313C33.247 24.1313 27.8379 18.7295 27.8379 12.0653C27.8379 5.40113 33.247 0 39.919 0C46.5909 0 52 5.40173 52 12.0659Z" fill="#C5C5C5"></path>
											<path d="M24.1615 12.0659C24.1615 22.68 16.5599 28.9959 11.8206 31.9032C11.2192 32.2719 10.5703 31.5058 11.0301 30.9693C12.5072 29.2446 14.2316 26.7791 15.3948 23.6709C14.3415 23.9712 13.2293 24.1313 12.0805 24.1313C5.40851 24.1313 0 18.7295 0 12.0659C0 5.40233 5.40851 0 12.0811 0C18.7536 0 24.1621 5.40173 24.1621 12.0659H24.1615Z" fill="#C5C5C5"></path>
										</svg>
									</div>
									<p className="text-center text-base mb-4">
										I am a certified nutritionist and personal trainer. Since 2020 I have tried to grow my online coaching business. I tried a thousand things.. But business didn't go anywhere. Mona helped me to rethink my strategies, find the niche that fits me best, and create a work environment that is sustainable for me. I have been able to raise my rates step by step. Super content with the training and especially the mentorship really helped me turn things around. I wish I had done it earlier.
									</p>
									<span className="font-semibold text-sm text-center w-full block">
										Health coach                        </span>
								</div>
							</div>
						</div>
						<div className="tns-item" aria-hidden="true" tabIndex="-1">
							<div className="w-full flex justify-center px-[80px]">
								<div className="max-w-[750px] w-full">
									<div className="w-full flex justify-center items-center mb-4">
										<svg width="52" height="32" viewBox="0 0 52 32" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M52 12.0659C52 22.68 44.3983 28.9959 39.6591 31.9032C39.0577 32.2719 38.4088 31.5058 38.8686 30.9693C40.3457 29.2446 42.0701 26.7791 43.2333 23.6709C42.18 23.9712 41.0678 24.1313 39.919 24.1313C33.247 24.1313 27.8379 18.7295 27.8379 12.0653C27.8379 5.40113 33.247 0 39.919 0C46.5909 0 52 5.40173 52 12.0659Z" fill="#C5C5C5"></path>
											<path d="M24.1615 12.0659C24.1615 22.68 16.5599 28.9959 11.8206 31.9032C11.2192 32.2719 10.5703 31.5058 11.0301 30.9693C12.5072 29.2446 14.2316 26.7791 15.3948 23.6709C14.3415 23.9712 13.2293 24.1313 12.0805 24.1313C5.40851 24.1313 0 18.7295 0 12.0659C0 5.40233 5.40851 0 12.0811 0C18.7536 0 24.1621 5.40173 24.1621 12.0659H24.1615Z" fill="#C5C5C5"></path>
										</svg>
									</div>
									<p className="text-center text-base mb-4">
										After 7 years working as a public teacher I needed a break. I love teaching, but dealing with uncooperative parents, admin, and unmotivated students sent me into a burn out. I tried private online teaching but couldn't find many students. Mona helped me navigate through all of it, marketing, content creation, even opened up new paths I could monetise right away. I'm fully booked and already built a waiting list. I'm a maths teacher and teach maths and EFL for stem online.
									</p>
									<span className="font-semibold text-sm text-center w-full block">
										Public school teacher                        </span>
								</div>
							</div>
						</div></div></div></div></div>
				</div>
			</section>

			<section className="py-16">
				<div className="container px-4">
					<div className="flex w-full justify-center mb-14">
						<div className="max-w-[550px]">
							<h2 className="text-[32px] text-jet font-semibold text-center mb-4">
								Benefits
							</h2>
							<div className="text-base text-jet font-normal text-center relative">
								<p>Work remote as a freelance
									<span className="min-w-[70px] text-center min-h-[18px] inline-block relative">
										<span className="text-center animated-text animated-text2 animated-text-center font-semibold top-0 inline-block w-full"></span>
									</span>. Set your own schedule, help others thrive, and grow your own independent business.</p>
							</div>
						</div>
					</div>
					<div className="grid md:grid-cols-3 gap-x-6 gap-y-14">
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={flexibility} alt="Flexibility" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">Flexibility
							</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Location freedom<br />
								Work online<br />
								Find clients globally

							</p>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={freedom_1} alt="Personal freedom" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">
								Personal freedom
							</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Be your own boss<br />
								Choose your clients<br />
								Lead an independent lifestyle
							</p>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={freedom_2} alt="Time freedom" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">Time freedom</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Set your own schedule<br />
								Healthy work-life balance<br />
								Find time for family and travel
							</p>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={freedom_3} alt="Financial freedom" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">
								Financial freedom
							</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Set your own rates and prices<br />
								Set your business up for growth<br />
								Gain stability and independence
							</p>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={rewarding_job} alt="Rewarding job" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">
								Rewarding job
							</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Help others thrive<br />
								Work with motivated people<br />
								Become a valued expert
							</p>
						</div>
						<div className="group rounded-[24px] bg-whiteSmoke relative p-8 flex flex-wrap justify-center">
							<div className="w-14 h-14 rounded-full flex justify-center items-center border-4 border-solid border-white absolute left-5 -top-7 bg-selectiveGreen">
								<img src={professional_success} alt="Professional success" />
							</div>
							<h3 className="text-[22px] text-jet font-medium text-center w-full">
								Professional success
							</h3>
							<div className="h-px w-[72px] bg-jet my-3"></div>
							<p className="text-jet text-sm text-center w-full">
								Grow your business at your own pace<br />
								Create your dream job<br />
								Build new income opportunities
							</p>
						</div>
					</div>
					<div className="justify-center flex mt-14">
						{/* <a href="https://ebook-sale.com" className="bg-jet text-white rounded-[10px] py-3 px-4 font-semibold text-sm text-center">
							EBOOK SALE
						</a> */}
					</div>
				</div>
			</section >
			<section className="bg-quiz-photo bg-no-repeat bg-center bg-cover relative">
				<div className="bg-selectiveGreen bg-opacity-80 z-0 absolute inset-0"></div>
				<div className="container px-4 relative z-10 py-16">
					<div className="flex w-full justify-center mb-14">
						<div className="max-w-[550px]">
							<h2 className="text-[32px] text-white font-semibold text-center">
								Are you ready to be a successful online <span className="min-w-[160px] text-center inline-block relative">
									<span className="text-center animated-text animated-text2 animated-text-center font-semibold top-0 inline-block w-full"></span>
								</span>?
							</h2>
						</div>
					</div>
					<div className="rounded-[24px] bg-jet px-6 py-8 bg-repeat md:animate-ltr-linear-infinite bg-numbers-texture flex flex-wrap transition-all duration-1000 justify-center inset-x-4 -mb-[200px]">
						<div className="w-full flex flex-wrap justify-center">
							<p className="text-base text-white font-normal text-center mb-6 w-full text-center max-w-[550px]">
								Take the quiz to define your goals, find out if you are prepared to go independent, and what to do next.
							</p>
						</div>
						<>
							{!showQuiz && <button onClick={() => setShowQuiz(true)} className="w-full py-3 px-4 rounded-[10px] bg-selectiveGreen text-white uppercase font-semibold text-sm min-h-[48px] mb-2 flex items-center justify-between max-w-[360px]">
								start!
								<svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z" fill="white"></path>
								</svg>
							</button>}
							<Quiz showQuiz={showQuiz} />
						</>
					</div>
				</div>
			</section>

			<FAQ />
			<section className="bg-whiteSmoke relative overflow-hidden">
				<div className="sm:absolute w-full sm:w-1/2 sm:top-0 sm:right-0 sm:bottom-0 h-[300px] sm:h-auto">
					<img className="object-cover object-top w-full h-full" src={require("./img/cta-photo.jpg")} alt="Footer call to action" />
				</div>
				<div className="container px-4 py-16">
					<div className="sm:w-1/2 sm:pr-4">
						<h2 className="text-[32px] text-jet font-semibold mb-4">
							Master the art of running an online education business.
						</h2>
						<div id="mc_embed_shell">
							<div id="mc_embed_signup">
								<form action="https://gmail.us18.list-manage.com/subscribe/post?u=3ca6323487982d5873fa80dd5&amp;id=0f7fa9b6eb&amp;f_id=001ec7e0f0" onSubmit={handleFormSubmit} method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_self">
									<div id="mc_embed_signup_scroll" className="grid gap-6 grid-cols-1 sm:max-w-[320px]">
										<label htmlFor="mce-FNAME">
											<span className="text-davyGray font-semibold text-sm w-full mb-2 block">
												NAME
											</span>
											<input type="text" name="FNAME" value={nameValue} onChange={(e) => { setNameValue(e.target.value) }}
												className={`w-full py-3 px-4 rounded-[10px] border-[0.5px] border-solid ${nameError ? 'border-red-400' : 'border-davyGray'} outline-0 bg-transparent font-normal text-davyGray`} placeholder="Provide your name" id="mce-FNAME" />
										</label>
										<label htmlFor="mce-EMAIL">
											<span className="text-davyGray font-semibold text-sm w-full mb-2 block">
												EMAIL
											</span>
											<input type="email" name="EMAIL" value={emailValue} onChange={(e) => { setEmailValue(e.target.value) }}
												className={`w-full py-3 px-4 rounded-[10px] border-[0.5px] border-solid ${emailError ? 'border-red-400' : 'border-davyGray'} outline-0 bg-transparent font-normal text-davyGray`} placeholder="Provide your e-mail" id="mce-EMAIL" />
										</label>
										<div className="pt-7">
											<button type="submit" className="w-full py-3 px-4 rounded-[10px] bg-selectiveGreen text-white uppercase font-semibold text-sm min-h-[48px] mb-2 flex items-center justify-between">
												ENROLL IN THE TRAINING PROGRAM
												<svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z" fill="white"></path>
												</svg>
											</button>
											<label>
												<input style={{ marginRight: '5px' }} checked={acceptTerms} onChange={handleAcceptTerms} type="checkbox" name="privacy" />
												<span className={`text-sm font-semibold ml-2 ${inputError ? 'text-red-400 underline' : 'text-davyGray'}`}>
													I accept the <a href="https://learntotutor.com/docs/PrivacyPolicy.pdf" rel="noreferrer" className="underline" target="_blank">privacy policy</a>
												</span>
											</label>
										</div>
										<div id="mce-responses" className="clear foot">
											<div className="response" id="mce-error-response hidden"></div>
											<div className="response" id="mce-success-response hidden"></div>
										</div>
										<div aria-hidden="true" style={{ position: "absolute", left: "-5000px" }}>
											{/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
											<input type="text" name="b_3ca6323487982d5873fa80dd5_0f7fa9b6eb" tabIndex="-1" />
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<footer className="py-6 bg-jet">
				<div className="container px-4 flex items-center gap-2 md:gap-6 justify-between">
					<a href="https://learntotutor.com/docs/PrivacyPolicy.pdf" rel='noreferrer' className="underline decoration-white text-white text-sm" target="_blank">
						Privacy Policy
					</a>
					<span className="text-selectiveGreen font-bold font-sans text-2xl">Learn<span className="text-selectiveYellow">To</span>Tutor</span>
					<span className="text-white text-sm">
						© 2024. All rights reserved.
					</span>
				</div>
			</footer>
		</>
	)
}

export default Landing